<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Franchisee Career Request
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.full_name"
                outlined
                readonly
                hide-details="auto"
                label="Full Name"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.age"
                outlined
                readonly
                hide-details="auto"
                label="Age"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone_no"
                outlined
                readonly
                hide-details="auto"
                label="Phone Number"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                readonly
                hide-details="auto"
                label="Email"
                prepend-inner-icon="mdi-email"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.address"
                outlined
                readonly
                hide-details="auto"
                label="Address"
                prepend-inner-icon="mdi-map-marker"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.city"
                outlined
                readonly
                hide-details="auto"
                label="City"
                prepend-inner-icon="mdi-city"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pin_code"
                outlined
                readonly
                hide-details="auto"
                label="Pin Code"
                prepend-inner-icon="mdi-map-marker-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="genderText"
                outlined
                readonly
                hide-details="auto"
                label="Gender"
                prepend-inner-icon="mdi-gender-male-female"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.applying_as"
                outlined
                readonly
                hide-details="auto"
                label="Applying As"
                prepend-inner-icon="mdi-briefcase"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="businessOperateText"
                outlined
                readonly
                hide-details="auto"
                label="Currently Operate Business"
                prepend-inner-icon="mdi-store"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.business_description"
                outlined
                readonly
                hide-details="auto"
                label="Business Description"
                prepend-inner-icon="mdi-text"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="franchiseeBusinessText"
                outlined
                readonly
                hide-details="auto"
                label="Has Franchisee Business"
                prepend-inner-icon="mdi-domain"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.franchisee_description"
                outlined
                readonly
                hide-details="auto"
                label="Franchisee Description"
                prepend-inner-icon="mdi-text"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="petIndustryExperienceText"
                outlined
                readonly
                hide-details="auto"
                label="Experienced in Pet Industry"
                prepend-inner-icon="mdi-star"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.proposed_franchisee_location"
                outlined
                readonly
                hide-details="auto"
                label="Proposed Franchisee Location"
                prepend-inner-icon="mdi-map-marker"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="workTypeText"
                outlined
                readonly
                hide-details="auto"
                label="Preferred Work Type"
                prepend-inner-icon="mdi-briefcase-variant"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.heard_from"
                outlined
                readonly
                hide-details="auto"
                label="Heard From"
                prepend-inner-icon="mdi-ear-hearing"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.support_interest"
                outlined
                readonly
                hide-details="auto"
                label="Support Interest"
                prepend-inner-icon="mdi-help-circle"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-autocomplete
                v-model="form.status"
                outlined
                hide-details="auto"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-checkbox-marked-circle-outline"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'franchise_owner_requests'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Franchisee Career Request
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "FranchiseeCareerRequestEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      statusItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
        { id: "REJECTED", text: "REJECTED", value: 2 },
      ],
      isLoading: false,
      isFetching: false,
    };
  },
  computed: {
    genderText() {
      if (this.form.gender === 0) return 'Male';
      if (this.form.gender === 1) return 'Female';
      if (this.form.gender === 2) return 'Other';
      return 'Not specified';
    },
    businessOperateText() {
      return this.form.currently_operate_business ? 'YES' : 'NO';
    },
    franchiseeBusinessText() {
      return this.form.has_franchisee_business ? 'YES' : 'NO';
    },
    petIndustryExperienceText() {
      return this.form.is_experienced_pet_industry ? 'YES' : 'NO';
    },
    workTypeText() {
      if (this.form.preferred_work_type === 0) return 'Full Time';
      if (this.form.preferred_work_type === 1) return 'Part Time';
      if (this.form.preferred_work_type === 2) return 'Freelance';
      return 'Not specified';
    }
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.franchiseeCareerRequestId;
      axios
        .get(`/franchisee_career_requests/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(`/franchisee_career_requests/${this.$route.params.franchiseeCareerRequestId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/franchisee-career-requests");
          })
          .catch((error) => {
            const errors = error.response?.data?.errors;
            if (errors) {
              this.isShowPopUP(
                "Could not save",
                Object.values(errors).flat().join(" "),
                "error",
              );
            } else {
              console.error(error);
              this.isUnAuthorised();
            }
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
